@if (lead && enabled) {
  <button
    class="transparent-btn"
    (click)="handleActionClick()"
    ngbTooltip="Modifier la demande"
    i18n-ngbTooltip="Modifier la demande"
  >
    <app-pen-2-icon height="16px" width="16px" color="var(--brand-500)" />
  </button>
  <app-update-lead
    #leadUpdateModal
    [lead]="lead"
    (leadUpdated)="refreshTaskDetails()"
    [preload]="false"
  />
}
